import React from 'react';
import axios from 'axios';
import { prepareUrl } from 'services/DataSource';
import { debounce } from 'services/utils';
import Autocomplete from 'components/autocomplete';

export default class AutocompleteAsync extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      items: [],
    }
    this.mounted = false;
    const {name: field, modelName: model} = props;
    if (!field) throw new Error("Autocomplete needs field name (name)");
    if (!model) throw new Error("Autocomplete needs model Name");
    this.requestParams = {
      model,
      field,
      q: '',
    }
    this.minQueryLength = props.minQueryLength || 3;
    this.debounceTime = props.debounceTime || 300;
    this.autocompleteUrl = prepareUrl(props.url || '/autocomplete');
  }

  componentDidMount() {
    this.mounted = true;
  }
  
  componentWillUnmount() {
    this.mounted = false;
  }

  getValue = (col) => {
    return this.props.valueProp ? (col[this.props.valueProp] || '') : col
  }
  
  getLabel = (col) => {
    return this.props.labelProp ? (col[this.props.labelProp] || '') : col
  }

  updateList() {
    const getDataMethod = (searchKey = '') => {
      if (searchKey.trim().length < this.minQueryLength) return;
      this.requestParams.q = searchKey.trim();
      axios.get(this.autocompleteUrl, { params: this.requestParams }).then(({data}) => {
        if (this.mounted) this.setState({ items: data });
      });
    }
    return debounce(getDataMethod, this.debounceTime);
  }

  render() {
    const { name, value, onChange, disabled, className } = this.props;
    return (
      <Autocomplete 
        name={name} 
        items={this.state.items} 
        getValue={this.getValue} 
        getLabel={this.getLabel} 
        value={value} 
        onChange={onChange}
        onSearchKeyChanged={this.updateList()}
        allowCreate={ this.props.labelProp ? false : true }
        disabled={disabled}
        className={className || ''}
      />
    )
  }
}
